import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import LazyMemberImage from "./LazyMemberImage";
import {
  formatAmount,
  getItemDetailsFromRedux,
  makeFirstCharCapital,
} from "../utils/commonUtils";
import { printReceipt } from "../utils/printReceipt";
import InvoiceModal from "./InvoiceModal";
import PaymentModal from "./PaymentModal";

const availableStatus = {
  Payment_Pending: "#c79305", // light blue
  Placed: "#057acd", // light blue
  Confirmed: "#04ca14", // light green
  Preparing: "#c49705", // light yellow
  Ready: "#04a6bc", // light cyan
  In_Delivery: "#a703c0", // light purple
  Delivered: "#03a155", // soft success green
  Delivery_Rejected: "#bf3a06", // light pink
  Could_Not_Deliver: "#900217", // light red
  Not_Placed: "#730303", // light grey
  Rejected: "#f60d0d", // soft red
};

// Order details card used on the home page orders list. Pass onStatusClick
// to make the status dropdown open the caller's update modal; without it
// the dropdown is display-only
const OrderCard = ({ order, onStatusClick, onPaymentDone }) => {
  const { userInfo } = useSelector((state) => state.auth);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showPayment, setShowPayment] = useState(false);

  const printBill = async (orderDetails) => {
    await printReceipt(orderDetails, userInfo, "manual");
  };

  // Print and Invoice are only offered for orders of wholesale outlets.
  // order.outletId may be a populated outlet or just its id
  const orderOutletId = String(order?.outletId?._id || order?.outletId || "");
  const isWholeSaleOrder = Boolean(
    userInfo?.outletId?.find((ot) => String(ot._id) === orderOutletId)
      ?.wholeSaleOutlet
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        justifyContent: "left",
        border: "0.5px solid #d7d2c3",
        borderRadius: "10px",
        padding: "0.5rem",
        width: "17rem",
        height: "14rem",
        backgroundColor: "#d9ebf9",
        fontSize: "0.9rem",
        background:
          "linear-gradient(to bottom right, #ffffff 10%, #e9eff5 80%, #deeff8 100%)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          justifyContent: "left",
          height: "13rem",
          overflow: "auto",
        }}
      >
        <div
          style={{
            borderBottom: "0.5px dotted grey",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: "0.2rem",
            marginBottom: "0.2rem",
          }}
        >
          <span
            style={{
              marginRight: "0.3rem",
              maxWidth: "3rem",
            }}
          >
            Id: {order.orderId}
          </span>
          <Form.Select
            style={{
              backgroundColor: "inherit",
              border: "0.5px solid #d7d2c3",
              color: availableStatus[order.orderStatus],

              maxWidth: "10rem",
            }}
            value={order?.orderStatus}
            onClick={() => onStatusClick && onStatusClick(order)}
          >
            <option value={order?.orderStatus}>{order?.orderStatus}</option>
            <option value="Placed">Placed</option>
            <option value="Confirmed">Confirmed</option>
            <option value="Preparing">Preparing</option>
            <option value="Ready">Ready</option>
            <option value="In_Delivery">In_Delivery</option>
            <option value="Delivered">Delivered</option>
            <option value="Delivery_Rejected">Delivery_Rejected</option>
            <option value="Could_Not_Deliver">Could_Not_Deliver</option>
            <option value="Not_Placed">Not_Placed</option>
            <option value="Rejected">Rejected</option>
          </Form.Select>
          <span
            style={{
              marginLeft: "0.3rem",
              maxWidth: "3rem",
            }}
          >
            {"Qty: "}
            {order.orderDetails.reduce(
              (total, item) => total + Number(item.itemQuantity),
              0
            )}
          </span>
        </div>
        {order.orderDetails?.map((item, index) => (
          <span
            key={index}
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              margin: "0.2rem",
            }}
          >
            <LazyMemberImage
              foodItemId={
                getItemDetailsFromRedux(item?.foodItemId, userInfo?.AllFoods)
                  ?._id
              }
              imageUpdatedTimeFromDB={
                getItemDetailsFromRedux(item.foodItemId, userInfo?.AllFoods)
                  ?.imageUploadedTime
              }
              currentlySelling={
                getItemDetailsFromRedux(item.foodItemId, userInfo?.AllFoods)
                  ?.currentlySelling
              }
              photoUploaded={
                getItemDetailsFromRedux(item.foodItemId, userInfo?.AllFoods)
                  ?.imageUploaded
              }
              width="2rem"
              height="2rem"
            />
            <span style={{ margin: "0.5rem" }}>
              {makeFirstCharCapital(item.itemName)}
              {item?.sizeName !== "Single Size" && (
                <small style={{ color: "green" }}>{item?.sizeName} </small>
              )}
              - {item.itemQuantity}{" "}
            </span>
          </span>
        ))}
      </div>{" "}
      <div>
        <span
          style={{
            fontSize: "0.8rem",
            paddingTop: "0.4rem",
            borderTop: "0.5px solid #d7d2c3",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* <span
            style={{
              color: "green",
            }}
          >
            {order.orderType}
          </span>{" "}
          {","}&nbsp; */}
          <span style={{ color: "orange" }}>
            Rs.{formatAmount(order.grossTotal)}
          </span>
          {","}&nbsp;
          {order.dueAmount > 0 && (
            <>
              <span style={{ color: "red" }}>
                Rs.{formatAmount(order.dueAmount)}
              </span>
              <button
                onClick={() => setShowPayment(true)}
                style={{
                  marginLeft: "0.1rem",
                  padding: "0 0.35rem",
                  fontSize: "0.6rem",
                  fontWeight: "600",
                  color: "#fff",
                  backgroundColor: "#28a745",
                  border: "none",
                  borderRadius: "999px",
                  cursor: "pointer",
                }}
              >
                Pay Now
              </button>{" "}
              &nbsp;
            </>
          )}
          {new Date(new Date(order?.createdAt).getTime() + 5.5 * 60 * 60 * 1000)
            .toISOString()
            .slice(11, 16)}
          {!isWholeSaleOrder && (
            <>
              {","}&nbsp;
              <label
                onClick={() => printBill(order)}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Print
              </label>{" "}
            </>
          )}{" "}
          {isWholeSaleOrder && (
            <>
              {","}&nbsp;
              <label
                onClick={() => setShowInvoice(true)}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                Invoice
              </label>{" "}
            </>
          )}
        </span>
      </div>{" "}
      {showInvoice && (
        <InvoiceModal
          show={showInvoice}
          onHide={() => setShowInvoice(false)}
          order={order}
        />
      )}
      {showPayment && (
        <PaymentModal
          show={showPayment}
          onHide={() => setShowPayment(false)}
          order={order}
          onSuccess={onPaymentDone}
        />
      )}
    </div>
  );
};

export default OrderCard;
